export default __webpack_public_path__ + "static/media/chatton14.0a0bffdc.jpeg";